var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.myLoading)?_c('div',{staticClass:"comp-full-loading"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.myLoading),expression:"myLoading"}],staticClass:"loading-anim"}),_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.title)+" "+_vm._s(_vm.point))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }